import React from 'react';
import './commuinty.css'

const Community = (props) => {
  return (
    <div 
      className={`cadivv ${props.stylee}`}  
                      
    >
      <img className='caion' src={props.caicon} alt="" />
      <h2 className='catextt'>{props.catext}</h2>
    </div>
  );
};

export default Community;